export default "__VITE_PUBLIC_ASSET__4e77fbf6__"